export default {
	setAccounts(ctx, payload) {
		const comparer = new Intl.Collator("en", { sensitivity: "base" });
		payload.sort((a, b) => comparer.compare(a.accountName, b.accountName));
		ctx.commit("SET_ACCOUNTS", payload);
	},
	setAssignedAccounts(ctx, payload) {
		ctx.commit("SET_ASSIGNED_ACCOUNTS", payload);
	},
	// addActiveAccounts(ctx, payload) {
	// 	let arr = ctx.state.assignedAccounts.concat(payload);
	// 	const unique = [
	// 		...new Map(arr.map((item) => [item.accountId, item])).values(),
	// 	];

	// 	ctx.state.assignedAccounts = unique;
	// },
	clearAccounts(ctx) {
		ctx.commit("SET_ACCOUNTS", null);
	},
};
